/**
 * @file score.js
 * @author Jiao(jiaoguibin@baidu.com)
 */
import './index.less';
import $ from 'jquery';
import * as img from './assets/index';

const html = `<div class="grade-box">
    <div class="grade-container">
        <div class="grade">
            <h5>请对本页内容打分</h5>
            <ul class="hover level">
                <li level=0 value="非常不满意"><img class="star" src="${img.star}"><img class="activestar" src="${img.activeStar}"></li>
                <li level=1 value="不满意"><img class="star" src="${img.star}"><img class="activestar" src="${img.activeStar}"></li>
                <li level=2 value="一般"><img class="star" src="${img.star}"><img class="activestar" src="${img.activeStar}"></li>
                <li level=3 value="比较满意"><img class="star" src="${img.star}"><img class="activestar" src="${img.activeStar}"></li>
                <li level=4 value="非常满意"><img class="star" src="${img.star}"><img class="activestar" src="${img.activeStar}"></li>
            </ul>
            <strong class="level-text"></strong>
        </div>
        <div class="close"><img src="${img.close}" alt="关闭"></div>
    </div>
</div>
<div class="doc-grade-fake-mask">
    <div class="dialog">
        <div class="dialog-head">
            <div class="title">步骤<span>1</span>/2</div>
            <div class="close"><img src="${img.close}" alt="关闭"></div>
        </div>
        <div class="dialog-content">
            <div class="step step1">
                <h3>请您对这篇文档进行评价</h3>
                <ul class="questions">
                    <li class="all" data-key="level">
                        <span>总体是否满意：</span>
                        <ul class="level whole">
                            <li level=0 value="非常不满意"><img class="star" src="${img.star}"><img class="activestar" src="${img.activeStar}"></li>
                            <li level=1 value="不满意"><img class="star" src="${img.star}"><img class="activestar" src="${img.activeStar}"></li>
                            <li level=2 value="一般"><img class="star" src="${img.star}"><img class="activestar" src="${img.activeStar}"></li>
                            <li level=3 value="比较满意"><img class="star" src="${img.star}"><img class="activestar" src="${img.activeStar}"></li>
                            <li level=4 value="非常满意"><img class="star" src="${img.star}"><img class="activestar" src="${img.activeStar}"></li>
                        </ul>
                        <strong class="level-text"></strong>
                    </li>
                    <li class="q1 q" data-key="q1">
                        <span>是否好找：</span>
                        <ul class="level detail">
                            <li level=0 value="非常不满意"><img class="init" src="${img.count1}"><img class="selected" src="${img.select1}"></li>
                            <li level=1 value="不满意"><img class="init" src="${img.count2}"><img class="selected" src="${img.select2}"></li>
                            <li level=2 value="一般"><img class="init" src="${img.count3}"><img class="selected" src="${img.select3}"></li>
                            <li level=3 value="比较满意"><img class="init" src="${img.count4}"><img class="selected" src="${img.select4}"></li>
                            <li level=4 value="非常满意"><img class="init" src="${img.count5}"><img class="selected" src="${img.select5}"></li>
                        </ul>
                        <strong class="level-text"></strong>
                    </li>
                    <li class="q2 q" data-key="q2">
                        <span>是否容易理解：</span>
                        <ul class="level detail">
                            <li level=0 value="非常不满意"><img class="init" src="${img.count1}"><img class="selected" src="${img.select1}"></li>
                            <li level=1 value="不满意"><img class="init" src="${img.count2}"><img class="selected" src="${img.select2}"></li>
                            <li level=2 value="一般"><img class="init" src="${img.count3}"><img class="selected" src="${img.select3}"></li>
                            <li level=3 value="比较满意"><img class="init" src="${img.count4}"><img class="selected" src="${img.select4}"></li>
                            <li level=4 value="非常满意"><img class="init" src="${img.count5}"><img class="selected" src="${img.select5}"></li>
                        </ul>
                        <strong class="level-text"></strong>
                    </li>
                    <li class="q3 q" data-key="q3">
                        <span>是否能解决您的问题：</span>
                        <ul class="level detail">
                            <li level=0 value="非常不满意"><img class="init" src="${img.count1}"><img class="selected" src="${img.select1}"></li>
                            <li level=1 value="不满意"><img class="init" src="${img.count2}"><img class="selected" src="${img.select2}"></li>
                            <li level=2 value="一般"><img class="init" src="${img.count3}"><img class="selected" src="${img.select3}"></li>
                            <li level=3 value="比较满意"><img class="init" src="${img.count4}"><img class="selected" src="${img.select4}"></li>
                            <li level=4 value="非常满意"><img class="init" src="${img.count5}"><img class="selected" src="${img.select5}"></li>
                        </ul>
                        <strong class="level-text"></strong>
                    </li>
                </ul>
                <button class="step1-btn btn">下一步</button>
            </div>
            <div class="step step2">
                <h3>请写下您的建议</h3>
                <textarea name="msg" id="" cols="30" rows="10"></textarea>
                <button class="step2-btn btn">提  交</button>
            </div>
        </div>
    </div>
</div>`;

// 文档评分的campainId
const levelId = '20170505_doc_level';
const api =' /api/survey/no_need_login/apply';
let gradeLevelSubmitAble = true;  // 是否可以提交的标识

const ajax = (api, data, header) => {
    return $.ajax({
        url: api,
        method: 'POST',
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify(data ? data : ''),
        headers: header ? {campaignId: header} : null
    });
}

// 数据提交公共函数
const sendData = (data, questionText) => {
    const levelData = scoreDataFormat(data, questionText, levelId);
    
    ajax(api, levelData);
};

/**
 * 数据格式整理
 * @param {topTitle: string, url: string, [propName: string]: any} data 
 * @param {[propName: string]: string} question 
 * @param {string} id 
 */
const scoreDataFormat = (data, question, id) => {
    const survey = [];
    const uniqueList = [];
    let temp;

    for (let x in data) {
        if (!data.hasOwnProperty(x)) {
            continue;
        }
        // 如果没有则置空，与后端约定
        data[x] = data[x] || '';

        // 整理提交数据格式
        const arr = typeof data[x] === 'string' ? [data[x]] : data[x];
        const answers = [];

        for (let y = 0; y < arr.length; y++) {
            answers.push({answer: arr[y]});
        }

        temp = {
            title: question[x],
            answers: answers,
            unique: uniqueList.indexOf(x) > -1
        };

        survey.push(temp);
    }

    return {
        questions: survey,
        from: '',
        campaignId: id
    };
}

// 弹框初始化
const dialogGradeInit = () => {
    const mask = $('.doc-grade-fake-mask');
    const dialog = mask.find('.dialog');
    const closeBtn = dialog.find('.close');
    const li = dialog.find('.level li');
    const gradeBtn = dialog.find('.step1-btn');
    const feedbackBtn = dialog.find('.step2-btn');

    // 弹框事件绑定
    closeBtn.on('click', () => {
        mask.hide();
    });

    $('document').on('click', () => {
        mask.hide();
    });

    dialog.on('click', e => {
        e.stopPropagation();
        return false;
    });

    // hover事件处理函数
    const hoverHandle = function () {
        const target = $(this);
        const parentLi = target.parents('li');
        const levelText = parentLi.find('.level-text');

        levelText.html(target.attr('value'));

        if (parentLi.hasClass('all')) {
            target.addClass('hover').prevAll().addClass('hover');
            target.nextAll().removeClass('hover');
            
            return;
        }

        target.addClass('hover').siblings().removeClass('hover');
    };

    // 置空评分
    const leaveHandle = function () {
        const levelText = $(this).parent().find('.level-text');
        
        $(this).find('li').removeClass('hover');
        levelText.html('');
    };

    // 弹框内部评分条鼠标事件
    dialog.find('.q .level li').on('mouseover', hoverHandle);
    dialog.find('.detail').on('mouseout', leaveHandle);

    // 弹框内部评分条点击事件
    li.on('click', function (e) {
        $(this).parent().unbind('mouseout', leaveHandle)
        .find('li').unbind('mouseover', hoverHandle);

        hoverHandle.call(this);
        e.stopPropagation();
    });

    // 提交弹框内评分数据
    gradeBtn.on('click', () => {
        let isComplete = true;  // 是否完整标识
        const res = {};

        // 校验数据
        dialog.find('.level-text').each(function(index, item) {
            const target = $(item);
            const text = target.text();
            const key = target.parent().data('key') || 'q';

            res[key] = text;

            if (text === '') {
                isComplete = false;
                target.text('请做出评价');
            }
        });

        // 不完整数据不允许提交
        if (!isComplete) {
            return false;
        }

        const topTitle = $('.post__title').text().trim();

        // 数据获取和提交
        const questionText = {
            topTitle: '文档标题',
            url: '文档连接',
            level: '评价等级',
            q1: '是否好找',
            q2: '是否容易理解',
            q3: '是否能解决您的问题'
        };

        const initData = {
            topTitle: topTitle,
            url: window.location.href
        };

        const data = Object.assign(initData, res);

        sendData(data, questionText);

        // 切换成弹框第二步内容，因为弹框内两步操作没有强先后依赖关系，所以这里不用在回调中操作
        dialog.find('.step1').hide();
        dialog.find('.step2').show();
        dialog.find('.dialog-head .title span').text('2');

        return false;
    });

    // 提交 用户建议 数据
    feedbackBtn.on('click', function () {
        const val = dialog.find('textarea').val();
        const topTitle = $('.post__title').text().trim();
        const data = {
            topTitle: topTitle,
            url: window.location.href,
            msg: val
        };
        const questionText = {
            topTitle: '文档标题',
            url: '文档连接',
            msg: '建议'
        };

        sendData(data, questionText);
        mask.hide();
    })
}

// 提交总体评价行为
const gradeLevelSubmit = () => {
    const main = $('body .grade-box');
    const choose = main.find('.level .choose').last();

    if (!gradeLevelSubmitAble) {
        return;
    }
    gradeLevelSubmitAble = false;

    if (!choose[0]) {
        main.find('.level-text').html('<span class="error">请给出该文档您的评价</span>');
        gradeLevelSubmitAble = true;
        return;
    }

    const level = choose.attr('level');
    const levelText = choose.attr('value');

    // 页面变动感知不到，每次都重新取
    const topTitle = $('.post__title').text().trim();

    const data = {
        topTitle: topTitle,
        url: window.location.href,
        level: '等级' + level + '：' + levelText
    };

    const questionText = {
        topTitle: '文档标题',
        url: '文档连接',
        level: '评价等级'
    };

    const levelData = scoreDataFormat(data, questionText, levelId);
    // 记录第一次提交的level
    window.gradeLevel = level;

    ajax(api, levelData).done(function (response) {
        if (response.success && response.result && response.result.code === 0) {
            if (main[0]) {
                main.remove();
            }

            $('.doc-grade-fake-mask').show();

            // 初始化弹框内容
            const whole = $('.doc-grade-fake-mask .whole');
            const middle = whole.find('[level=' + window.gradeLevel +']');
            const text = middle.attr('value');

            middle.addClass('hover').prevAll().addClass('hover');
            whole.parent().find('.level-text').text(text);

            return;
        }
        alert(response.message ? response.message.global : '网络错误，反馈失败，请稍后重试');
    }).then(function () {
        gradeLevelSubmitAble = true;
    });
};

/**
 * 更新评分样式
 * @param {jQuery} me 被点击的星星
 */
const refreshGradeView = (me) => {
    const parent = me.parent();

    if (parent.hasClass('hover')) {
        parent.removeClass('hover').addClass('press');
    }

    parent.find('.choose').removeClass('choose');
    me.addClass('choose').prevAll().addClass('choose');
}

const init = () => {
    const gradeContainer = $('.template-grade');
    let main = gradeContainer.find('.grade-box');

    if (main[0]) {
        return;
    }

    // 加载评分条html
    gradeContainer.html(html);

    main = gradeContainer.find('.grade-box');

    const levelText = main.find('.level-text');

    // 评分条事件绑定
    // 关闭 或 点击评分
    main.find('.grade-container .close, .feedback-grade-button').on('click', () => {
        if (main[0]) {
            main.remove();
        }
    });

    // 点击评分
    main.find('.level li').on('click', function () {
        const me = $(this);

        refreshGradeView(me);
        gradeLevelSubmit();
    });

    // 整体评分条hover事件
    main.find('.level li').on('mouseover', function () {
        levelText.html($(this).attr('value'));
    });
    main.find('.level').on('mouseout', () => {
        levelText.html('');
    });

    main.find('.level li').hover(function () {
        $(this).addClass('hover').prevAll().addClass('hover');
    }, function () {
        $(this).removeClass('hover').prevAll().removeClass('hover');
    });

    // 弹框初始化
    dialogGradeInit();
}

export default init;
